export var animatedScrollTo = function animatedScrollTo(elementY) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  return new Promise(function (resolve) {
    var startingY = window.pageYOffset;
    var diff = window.pageYOffset + elementY - startingY;
    var start;
    var step = function step(timestamp) {
      if (!start) {
        start = timestamp;
      }
      var time = timestamp - start;
      var percent = Math.min(time / duration, 1);
      window.scrollTo(0, startingY + diff * percent);
      if (time < duration) {
        window.requestAnimationFrame(step);
      }
      if (time >= duration) {
        resolve(true);
      }
    };
    window.requestAnimationFrame(step);
  });
};